import { EMPTY_OBJECT } from 'uf/base';
import { LayersState } from 'uf/layers/state';
import { UFState } from 'uf/state';

export function getLayersState(state: UFState) {
  return (state.layers || EMPTY_OBJECT) as LayersState;
}
